import {setWorkItemStatus, log, logMetric} from "../../ApiCalls";
import {LoadingIcon} from "../../Common";

import {StatusEnum} from "../../../../Types/StatusEnum";

import {azureTokenContext, messageBoxContext, userIdContext} from "../../../../App";

import {Dialog, DialogPanel, DialogTitle, Transition, TransitionChild} from '@headlessui/react'
import React, {Fragment, useContext, useState} from 'react'
import {makeMetricPayloadByPriorityNumber} from "../OpenDocumentDropdown";


export default function SetToReviewModal({
                                             isOpen,
                                             setIsOpen,
                                             task,
                                             setAllTasks,
                                             setSelectedTasks
                                         }) {
    let setMessageBoxProp = useContext(messageBoxContext);
    const userId = useContext(userIdContext);
    const azureToken = useContext(azureTokenContext);
    const [isPending, setIsPending] = useState(false);

    const confirmAction = async () => {
        setIsPending(true);
        try {
            const response = await setWorkItemStatus(StatusEnum.readyForReview, task.WorkItemId, userId, azureToken);
            if (response.Success === true) {
                updateTasks();
                log("INFO", `Author set task to readyForReview for WorkItemId: ${task.WorkItemId}`, "AuthorsPortal", task.WorkItemId, "Author", userId, azureToken);
                const payload = makeMetricPayloadByPriorityNumber(task.PriorityNumber);
                logMetric("AuthorsPortal", "Author set task to readyForReview", "Success", "", "Author set task to readyForReview", task.WorkItemId, "Author", userId, azureToken, payload);
                setMessageBoxPropFunc("SuccessSetToReview");
            } else {
                await logFailure(response.Message);
                setMessageBoxPropFunc("ErrorSetToReview");
            }
        } catch (error) {
            console.log("ErrorSetToReview", error);
            await logFailure(error instanceof Error ? error.message : 'Unknown error');
            setMessageBoxPropFunc("ErrorSetToReview");
        } finally {
            setIsPending(false);
            setIsOpen(false);
        }
    }

    const updateTasks = () => {
        let newTask = {...task};
        newTask.Status = StatusEnum.readyForReview;
        newTask.WorkItemStatus = StatusEnum.readyForReview;
        newTask.DueDate = "";
        newTask.Description = "Vent på innspill fra fagredaktør og korrekturleser";

        // Update the task in allTasks and selectedTasks
        setAllTasks((prevTasks) =>
            prevTasks.map((t) =>
                t.TaskId === newTask.TaskId ? {...t, ...newTask} : t
            )
        );
        setSelectedTasks((prevTasks) =>
            prevTasks.map((t) =>
                t.TaskId === newTask.TaskId ? {...t, ...newTask} : t
            )
        );
    }

    const logFailure = async (message: string) => {
        log("ERROR", `Failed to set task to readyForReview for WorkItemId: ${task.WorkItemId}. Message: ${message}`, "AuthorsPortal", task.WorkItemId, "Author", userId, azureToken);
        const payload = makeMetricPayloadByPriorityNumber(task.PriorityNumber);
        logMetric("AuthorsPortal", "Failed to set task to readyForReview", "Failed", "", `Failed to set task to readyForReview for WorkItemId: ${task.WorkItemId}`, task.WorkItemId, "Author", userId, azureToken, payload);
    };

    const setMessageBoxPropFunc = (prop: string) => {
        // since it is invocated by changes in prop, I want to make sure that it changes
        setMessageBoxProp("");
        setTimeout(() => {
            setMessageBoxProp(prop);
        }, 10);
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={() => setIsOpen(false)}>
                <TransitionChild
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25"/>
                </TransitionChild>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <TransitionChild
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <DialogPanel
                                className="w-full max-w-3xl max-h-96 transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <DialogTitle
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900"
                                >
                                    Sett til vurdering
                                </DialogTitle>
                                <div className="modal-paragraph-container">
                                    <p>
                                        <b>Er du sikker på at du vil sette hele manuset til vurdering?</b>
                                        <br/>
                                        Merk at du kan ha flere utestående oppgaver.
                                        <br/>
                                        <br/>
                                        <b>Har du bare gjennomgått deler av manuset (for eksempel noter påvirket av lovendringer)?</b>
                                        <br/>
                                        Send en e-post til support@karnovgroup.no, så hjelper vi deg med å klippe ut det som er klart.
                                    </p>
                                </div>

                                <div className="mt-4">
                                    <button
                                        type="button"
                                        className="confirm-button"
                                        onClick={() => confirmAction()}
                                        disabled={isPending}
                                    >
                                        {isPending && (
                                            <LoadingIcon/>
                                        )}
                                        Ja, sett hele manuset til vurdering.
                                    </button>
                                    <button
                                        type="button"
                                        className="cancel-button"
                                        onClick={() => setIsOpen(false)}
                                        disabled={isPending}
                                    >
                                        {isPending && (
                                            <LoadingIcon/>
                                        )}
                                        Avbryt
                                    </button>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

